export function customChartData() {
  return {
    chart: {
      title: false,
      spacingTop: 25,
      height: 260,
      backgroundColor: 'transparent'
    },
    tooltip: {
      valueDecimals: 2
    },
    colors: ['#FFFFFF', '#66CBE0'],
    series: [
      {
        pointPadding: 0.2,
        states: {
          hover: {
            color: '#EBECEF'
          }
        }
      },
      { pointPadding: 0.3 }
    ],
    yAxis: {
      tickAmount: 5,
      labels: {
        style: {
          color: 'white'
        }
      },
      gridLineColor: '#9A9FAE'
    },
    xAxis: {
      labels: {
        rotation: 0,
        style: {
          color: 'white'
        }
      }
    }
  }
}
